import { Alert, Drawer, Switch, Tabs, message } from 'antd';
import { useContext, useState } from 'react';
import { AutomateReviewsTab } from './AutomateReviewsTab';
import { CompanyIAGuide } from '../../../../../components/model/ia/CompanyIAGuide';
import { SettingOutlined } from '@ant-design/icons';
import { DrawerContext } from '../../../../../../store/DrawerContext/DrawerContext';
import { useFetch } from '../../../../../../hooks/useFetch/useFetch';
import { useAuth } from '../../../../../../store/AuthContext/AuthContext';
import { authRequest } from '../../../../../../common/request/authRequest';
import { GlobalVariableContext } from '../../../../../../store/GlobalVariableContext/GlobalVariableContext';
import { TestReplyWithAIDrawer } from './TestReplyWithAIDrawer';
import { DrawerPanelTitle, drawerPanelStyles } from '../../../../common/Drawers/DrawerPanelTitle';

export const ConfigureIAByLocalDrawer = () => {

	const { configureIAByLocalDrawer, setConfigureIAByLocalDrawer } = useContext(DrawerContext);

	const [openDrawer, setOpenDrawer] = useState(false);
	const [updateData, setUpdateData] = useState(false);
	const [isLoading, setIsLoading] = useState(true);
	const [location, setLocation] = useState();
	const [configIALocal, setConfigIALocal] = useState<boolean>();
	const { projectGroup } = useAuth();
	const { updateGlobalData, setUpdateGlobalData } = useContext(GlobalVariableContext);

	const changeStatus = (isLocalActive: boolean) => {
		const data = {
			localConfig: isLocalActive
		};

		authRequest(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/${projectGroup.group}/ia/localConfig/${configureIAByLocalDrawer}`, { method: 'PATCH', data: data })
			.then(() => {
				message.success('Estado cambiado con éxito');
				setUpdateData(!updateData);
			}).catch(() => {
				message.error('Error inesperado');
			});
	};

	useFetch(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/${projectGroup.group}/ia/guide/${configureIAByLocalDrawer}`, {}, [updateData], (data) => {
		setConfigIALocal(data.configIALocal);
		setLocation(data.location);
		setIsLoading(false);
	});

	return (
		<Drawer
			placement="right"
			width={'40%'}
			title={
				<DrawerPanelTitle
					title={<><SettingOutlined /> Respuestas con IA</>}
					subtitle="Afecta solo al local seleccionado"
					location={location}
				/>
			}
			onClose={() => setConfigureIAByLocalDrawer(false)}
			open={true}
			{...drawerPanelStyles}
		>
			<div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginBottom: 8 }}>
				<Switch
					checked={configIALocal}
					unCheckedChildren='Configuración por Grupo'
					checkedChildren='Configuración por Local'
					onChange={(e: boolean) => {
						changeStatus(e);
						setUpdateGlobalData(!updateGlobalData);
					}}
				/>
			</div>
			{configIALocal ? (
				<Tabs defaultActiveKey="1" type="line" style={{ width: '100%' }}>
					<Tabs.TabPane tab={<span className='title-tabPane'>Personalizar</span>} key="1">
						<CompanyIAGuide
							locationId={configureIAByLocalDrawer}
							onTestClick={() => setOpenDrawer(true)}
						/>
					</Tabs.TabPane>

					<Tabs.TabPane tab={<span className='title-tabPane'>Automatizar</span>} key="2">
						<AutomateReviewsTab openDrawer={false} setOpenDrawer={undefined} locationId={configureIAByLocalDrawer} />
					</Tabs.TabPane>
				</Tabs>
			) : (
				<div>
					<Alert
						style={{ padding: '20px', margin: '20px 0px' }}
						message="Configuración heredada del grupo"
						description="La configuración de este local se basa en la configuración general del grupo"
						type="info"
						showIcon
					/>
				</div>
			)}

			{openDrawer && (
				<TestReplyWithAIDrawer
					openDrawer={openDrawer}
					setOpenDrawer={setOpenDrawer}
					locationId={configureIAByLocalDrawer}
				/>
			)}
		</Drawer>
	);
};
